import { replacer } from '@interflora/ui-components/build/utils/common'
const LOG_FORMATTING = false

/* Replace nulls with empty string throughout an object */
export const replaceNulls = (object: any) =>
  replacer(
    object,
    (key, value) => null === value,
    (key, value) => {
      LOG_FORMATTING && console.log('Replacing', key, value, 'with empty string')
      return ''
    }
  )

/* Replace nulls with false throughout an object */
export const replaceNullsWithBoolean = (object: any, booleanValue = false) =>
  replacer(
    object,
    (key, value) => null === value,
    (key, value) => {
      LOG_FORMATTING && console.log('Replacing', key, value, 'with', booleanValue)
      return booleanValue
    }
  )
